import { FormattedDate } from 'components/misc/FormattedDate';
import { TimerLog } from 'types/timecards';

type Props = {
    timerLogs?: TimerLog[];
};

export const TimerLogsList = ({ timerLogs }: Props): JSX.Element => {
    const sorted = [...(timerLogs ?? [])].sort((a, b) => a.startedAt.localeCompare(b.startedAt));

    return (
        <ol className="flex flex-col gap-1 text-sm">
            {sorted.map((log, index) => (
                // oxlint-disable-next-line react-doctor/no-array-index-as-key -- logs have no stable id; list is not reordered/filtered after mount
                <li key={`timer-log-${index}`} className="flex items-center gap-1">
                    <FormattedDate value={log.startedAt} withTime />
                    <span>–</span>
                    <FormattedDate value={log.stoppedAt} withTime />
                </li>
            ))}
        </ol>
    );
};
